import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Link } from '@react-pdf/renderer';
import logoamerisa from '../assets/logoamerisazul.png';

// Método para obtener URL de imagen de Google Drive usando el proxy del backend
const getGoogleDriveImageUrl = (fileId) => {
  return `${process.env.REACT_APP_API_URL}/api/v1/proxy/drive-image/${fileId}`;
};

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    padding: 30,
    paddingBottom: 60, // Reservar espacio para el pie de página (ajusta si tu footer es más alto)
    backgroundColor: '#ffffff',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '1pt solid #eaeaea',
  },
  logo: {
    width: 120,
    height: 40,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#2c5282', // Azul oscuro
  },
  headerReference: {
    fontSize: 10,
    color: '#555555',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 15,
    textTransform: 'uppercase',
    color: '#2a4365', // Azul muy oscuro
    paddingBottom: 5,
    borderBottom: '1pt solid #90cdf4', // Línea azul clara
  },
  subtitle: {
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 15,
    backgroundColor: '#ebf8ff', // Azul muy claro
    padding: 6,
    borderRadius: 3,
    color: '#2c5282', // Azul oscuro
    borderLeft: '4pt solid #63b3ed', // Borde izquierdo azul
  },
  section: {
    marginBottom: 15,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
  },
  label: {
    fontWeight: 'bold',
    marginRight: 5,
  },
  value: {
    flex: 1,
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  gridItem: {
    width: '50%',
    marginBottom: 8,
    paddingRight: 10,
  },
  statusBox: {
    padding: 10,
    marginTop: 10,
    marginBottom: 15,
    borderRadius: 5,
  },
  statusBoxAutorizado: {
    backgroundColor: '#e6ffed',
    borderLeft: '5pt solid #52c41a',
  },
  statusBoxRechazado: {
    backgroundColor: '#fff2f0',
    borderLeft: '5pt solid #ff4d4f',
  },
  itemAutorizado: {
    backgroundColor: '#f6ffed',
    padding: 5,
    marginBottom: 5,
    borderRadius: 3,
  },
  itemRechazado: {
    backgroundColor: '#fff2f0',
    padding: 5,
    marginBottom: 5,
    borderRadius: 3,
  },
  footer: {
    // position: 'absolute',
    // bottom: 30,
    // left: 40,
    // right: 40,
    borderTop: '1pt solid #ddd',
    paddingTop: 10,
    fontSize: 8,
    textAlign: 'center',
  },
  pageNumber: {
    // position: 'absolute',
    // bottom: 30,
    // right: 40,
    fontSize: 10,
  },  dateTime: {
    // position: 'absolute',
    // bottom: 30,
    // left: 40,
    fontSize: 10,
  },  evidenceContainer: {
    marginTop: 10,
    marginBottom: 5,
    padding: 5,
    backgroundColor: '#f9f9f9',
    borderRadius: 3,
  },
  evidenceTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  evidenceImage: {
    width: 150,
    height: 100,
    objectFit: 'cover',
    marginRight: 5,
    marginBottom: 5,
    border: '1pt solid #ddd',
    borderRadius: 2,
  },
  evidenceImagesGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
});

const formatearFecha = (fechaString) => {
  if (!fechaString) return 'No especificada';
  const fecha = new Date(fechaString);
  return fecha.toLocaleDateString('es-MX', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const AuditoriaDocument = ({ auditoria }) => {
  const esAutorizado = auditoria?.estatus === 'AUTORIZADO';
  return (
    <Document>
      {/* PRIMERA PÁGINA: Información general, diseño moderno y organizado */}
      <Page size="A4" style={styles.page} wrap>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <Image src={logoamerisa} style={{ width: 120, height: 40 }} />
          <View style={{ alignItems: 'flex-end' }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Auditoría: AC-{auditoria?.id || 'N/A'}</Text>
            <Text style={{ fontSize: 10, color: '#555' }}>Fecha: {formatearFecha(auditoria?.created_at)}</Text>
          </View>
        </View>
        <Text style={{ fontSize: 22, fontWeight: 'bold', color: '#2a4365', textAlign: 'center', marginBottom: 8, letterSpacing: 1 }}>REPORTE DE AUDITORÍA DE CALIDAD</Text>
        <View style={{ flexDirection: 'row', justifyContent: 'center', marginBottom: 18 }}>
          <View style={{ backgroundColor: esAutorizado ? '#e6ffed' : '#fff2f0', borderRadius: 8, padding: 12, minWidth: 180, alignItems: 'center', borderLeft: esAutorizado ? '6pt solid #52c41a' : '6pt solid #ff4d4f' }}>
            <Text style={{ fontWeight: 'bold', fontSize: 15, color: esAutorizado ? '#237804' : '#a8071a' }}>Estatus: {auditoria?.estatus || 'N/A'}</Text>
          </View>
        </View>
        <View style={{ marginBottom: 18 }}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#2c5282', marginBottom: 8, borderLeft: '4pt solid #63b3ed', paddingLeft: 8 }}>Información del Embarque</Text>
          <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Camión:</Text> <Text>{auditoria?.camion || 'N/A'}</Text>
            </View>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Operador:</Text> <Text>{auditoria?.operador || 'N/A'}</Text>
            </View>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Tractor:</Text> <Text>{auditoria?.tractor || 'N/A'}</Text>
            </View>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Remolque:</Text> <Text>{auditoria?.remolque || 'N/A'}</Text>
            </View>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>LT:</Text> <Text>{auditoria?.lt || 'N/A'}</Text>
            </View>
            <View style={{ width: '48%', marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Destino:</Text> <Text>{auditoria?.destino || 'N/A'}</Text>
            </View>
          </View>
        </View>
        <View style={{ marginBottom: 18 }}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#2c5282', marginBottom: 8, borderLeft: '4pt solid #63b3ed', paddingLeft: 8 }}>Resultados de la Evaluación</Text>
          <View style={{ backgroundColor: '#f7fafc', borderRadius: 6, padding: 10 }}>
            <View style={{ marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Fauna Nociva:</Text> <Text>{auditoria?.fauna_nociva ? 'Detectada' : 'No detectada'}</Text>
            </View>
            <View style={{ marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Filtraciones:</Text> <Text>{auditoria?.filtracion ? 'Detectadas' : 'No detectadas'}</Text>
            </View>
            <View>
              <Text style={{ fontWeight: 'bold', color: '#2a4365' }}>Estado Físico:</Text> <Text>{auditoria?.estado_fisico || 'N/A'}</Text>
            </View>
          </View>
        </View>
        {auditoria?.comentarios && (
          <View style={{ marginBottom: 18 }}>
            <Text style={{ fontSize: 13, fontWeight: 'bold', color: '#2c5282', marginBottom: 4, borderLeft: '4pt solid #63b3ed', paddingLeft: 8 }}>Comentarios</Text>
            <Text style={{ color: '#555', fontSize: 10 }}>
              "{auditoria.comentarios}"
            </Text>
          </View>
        )}
        <View style={{ position: 'absolute', left: 30, right: 30, bottom: 30 }}>
          <View style={styles.footer}>
            <Text>
              AMERISA LOGISTICS - Este documento es un reporte oficial de auditoría de calidad.
              Cualquier duda favor de comunicarse al departamento de calidad.
            </Text>
          </View>
          <Text style={styles.dateTime}>
            Generado: {formatearFecha(new Date().toISOString())}
          </Text>
          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} />
        </View>
      </Page>
      {/* SEGUNDA PÁGINA: Solo evidencias fotográficas, agrupadas y con títulos */}
      <Page size="A4" style={styles.page} wrap>
        <Text style={{ fontSize: 16, fontWeight: 'bold', color: '#2a4365', textAlign: 'center', marginBottom: 16, letterSpacing: 1 }}>EVIDENCIAS FOTOGRÁFICAS</Text>
        {/* Fauna Nociva */}
        {auditoria?.fauna_nociva && auditoria?.fauna_img && auditoria.fauna_img.length > 0 && (
          <View style={{ marginBottom: 18 }}>
            <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#2c5282', marginBottom: 6 }}>Fauna Nociva</Text>
            <View style={styles.evidenceImagesGrid}>
              {auditoria.fauna_img.map((imageId, index) => (
                <View key={index} style={{ marginRight: 5, marginBottom: 12, alignItems: 'center' }} wrap={false} break minPresenceAhead={200}>
                  <Image 
                    src={getGoogleDriveImageUrl(imageId)} 
                    style={styles.evidenceImage}
                    cache={false}
                  />
                  <Text style={{ fontSize: 7, textAlign: 'center', color: '#777' }}>
                    Imagen {index + 1}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}
        {/* Filtraciones */}
        {auditoria?.filtracion && auditoria?.filtracion_img && auditoria.filtracion_img.length > 0 && (
          <View style={{ marginBottom: 18 }}>
            <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#2c5282', marginBottom: 6 }}>Filtraciones</Text>
            <View style={styles.evidenceImagesGrid}>
              {auditoria.filtracion_img.map((imageId, index) => (
                <View key={index} style={{ marginRight: 5, marginBottom: 12, alignItems: 'center' }} wrap={false} break minPresenceAhead={200}>
                  <Image 
                    src={getGoogleDriveImageUrl(imageId)} 
                    style={styles.evidenceImage}
                    cache={false}
                  />
                  <Text style={{ fontSize: 7, textAlign: 'center', color: '#777' }}>
                    Imagen {index + 1}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}
        {/* Estado Físico */}
        {auditoria?.estado_img && auditoria.estado_img.length > 0 && (
          <View style={{ marginBottom: 18 }}>
            <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#2c5282', marginBottom: 6 }}>Estado Físico</Text>
            <View style={styles.evidenceImagesGrid}>
              {auditoria.estado_img.map((imageId, index) => (
                <View key={index} style={{ marginRight: 5, marginBottom: 12, alignItems: 'center' }} wrap={false} break minPresenceAhead={200}>
                  <Image 
                    src={getGoogleDriveImageUrl(imageId)} 
                    style={styles.evidenceImage}
                    cache={false}
                  />
                  <Text style={{ fontSize: 7, textAlign: 'center', color: '#777' }}>
                    Imagen {index + 1}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}
        <View style={{ position: 'absolute', left: 30, right: 30, bottom: 30 }}>
          <View style={styles.footer}>
            <Text>
              AMERISA LOGISTICS - Este documento es un reporte oficial de auditoría de calidad.
              Cualquier duda favor de comunicarse al departamento de calidad.
            </Text>
          </View>
          <Text style={styles.dateTime}>
            Generado: {formatearFecha(new Date().toISOString())}
          </Text>
          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} />
        </View>
      </Page>
    </Document>
  );
};

export default AuditoriaDocument;
